import {io} from "socket.io-client";
import type {Socket} from "socket.io-client";
import {PUBLIC_WS_URL} from "$env/static/public";
import type {ChatMessageWs} from "$lib/types";

let chatSocket: Socket | null = null;
const NEW_MESSAGE = "new message";

export function connect(jwt: string): boolean {
  if (chatSocket) return false;
  chatSocket = io([PUBLIC_WS_URL, "?token=", jwt].join(""));
  return true;
}

/**
 * функция подписчик на уведомления о сообщениях в чатах
 * @param fn { (message: ChatMessageWs) => void } формат хандлера
 */
export function chatNotify(fn: (message: ChatMessageWs) => void): boolean {
  if (!chatSocket) {
    // TODO: send to sentry
      // console.error("chat socket is not yet");
      return false;
  }

  chatSocket.on(NEW_MESSAGE, (message) => {
    /*
    data: {
      chatId : 2
      createdAt : "2023-07-10T08:39:23.325Z"
      text : "пфывафывафывафыаким почеркфывафывафом 2"
      userId : 2
    }
     */

    if (!message.data || !message.data.chatId) {
      console.error("Unexpected websocket response");
      return;
    }

    fn(message.data as ChatMessageWs);


  });

  return true;
}
